import { render, staticRenderFns } from "./UniqueIndexes.vue?vue&type=template&id=15c78841&scoped=true"
import script from "./UniqueIndexes.vue?vue&type=script&lang=js"
export * from "./UniqueIndexes.vue?vue&type=script&lang=js"
import style0 from "./UniqueIndexes.vue?vue&type=style&index=0&id=15c78841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c78841",
  null
  
)

export default component.exports